<div class="">
  <div class="card card-w-title">
    <div class="address-update">
      <input type="text" size="40" disabled="disabled" pInputText [(ngModel)]="addresspoint.address" />

      <div *ngIf="typeaddress">
        <div (click)="updateAddressPoint(addresspoint.address)">
          <i class="pi pi-user-edit" style="font-size: 3em" aria-hidden="true"></i>
        </div>
        <div (click)="deletePointAddress(addresspoint.id)"><i class="pi pi-times" style="font-size: 3em" aria-hidden="true"></i></div>
      </div>
    </div>
    <div class="address-client_name">
      <p>Cliente</p>
      <p>{{ addresspoint.id }}</p>
    </div>
  </div>
</div>

<p-dialog header="" [(visible)]="showDeleteAddress" [style]="{ width: '50vw' }">
  <div class="content-delete-address">
    <div class="content-delete-address_warning">
      <h2>¿Eliminar dirección?</h2>
      <p>La dirección se borrará definitivamente de la lista de lugares.</p>
    </div>
    <div class="content-delete-address_buttons">
      <button (click)="validateDeleteAddress(false)" pButton label="Volver" class="btn-address_delete"></button>
      <button (click)="validateDeleteAddress(true)" pButton label="Eliminar" class="ui-button-danger btn-address_delete"></button>
    </div>
  </div>
</p-dialog>
